var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1726 12.0052L21.7458 3.43205C22.0766 3.11249 22.0858 2.58521 21.7663 2.25433C21.4467 1.92344 20.9194 1.91426 20.5885 2.23383C20.5816 2.24052 20.5748 2.24735 20.568 2.25433L11.9948 10.8275L3.42161 2.25428C3.09072 1.93471 2.56345 1.94389 2.24388 2.27478C1.93213 2.59756 1.93213 3.10927 2.24388 3.43205L10.8171 12.0052L2.24388 20.5784C1.91871 20.9036 1.91871 21.4309 2.24388 21.7561C2.56911 22.0813 3.09639 22.0813 3.42161 21.7561L11.9948 13.183L20.568 21.7561C20.8989 22.0757 21.4261 22.0665 21.7457 21.7356C22.0574 21.4129 22.0574 20.9012 21.7457 20.5784L13.1726 12.0052Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/icon-cancel.75f99fa7b24eecea064fb6446946bc51.svg";
export { ForwardRef as ReactComponent };